module.exports = __webpack_public_path__ + "capa.f83cf6ed80df41d983ea.jpg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/img/capa.jpg
// module id = ../../../../../src/assets/img/capa.jpg
// module chunks = main